/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/** @jsx jsx */
import { jsx } from '@emotion/react'
import { Fragment } from 'react'

import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiHorizontalRule,
  EuiPanel,
  EuiSpacer,
  EuiText,
} from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

import useFilters from '../useFilters'
import PricingInfoPanel from '../../PricingInfoPanel'

import FiltersSection from './FiltersSection'
import CSVSection from './CSVSection'
import GroupSection from './GroupSection'

interface Props {
  isLoading: boolean
}

const PanelWidth = '295px'

const FiltersPanel = ({ isLoading }: Props) => {
  const { filters } = useFilters()

  return (
    <EuiPanel hasBorder={false} hasShadow={false} paddingSize='l' color='subdued'>
      <EuiFlexGroup direction='column' gutterSize='m'>
        <EuiFlexItem grow={false}>
          <EuiText size='s'>
            <h3>
              <FormattedMessage id='billing-usage.filters.title' defaultMessage='View controls' />
            </h3>
          </EuiText>
          <EuiSpacer size='s' />
          <EuiFlexItem grow={false}>
            <EuiText size='xs'>
              <FormattedMessage
                id='billing-usage.filters.subtitle'
                defaultMessage='Adjust the usage chart and table data'
              />
            </EuiText>
          </EuiFlexItem>
        </EuiFlexItem>
        <EuiFlexItem grow={false} css={{ minWidth: PanelWidth }}>
          <EuiFlexGroup direction='column' gutterSize='m'>
            {!filters.instanceId && (
              <Fragment>
                <EuiHorizontalRule margin='none' />
                <GroupSection />
              </Fragment>
            )}
            <EuiHorizontalRule margin='none' />
            <FiltersSection isLoading={isLoading} />
            <EuiHorizontalRule margin='none' />
            <CSVSection />
            <EuiHorizontalRule margin='none' />
            <PricingInfoPanel />
          </EuiFlexGroup>
        </EuiFlexItem>
      </EuiFlexGroup>
    </EuiPanel>
  )
}

export default FiltersPanel
